<template>
	<div ref="header" class="header_container_x">
		<div class="top_bar">
			<a
				href="https://gitasbnc.bnc.com.cn/index#/login"
				target="_blank"
				rel="noopener noreferrer"
				style="margin-right: 20px;"
				><button class="header_email el-icon-s-custom" style="cursor: pointer;"></button
			></a>
			<a
				href="http://mail.bnc.com.cn/webmail7.5/webmail.php"
				target="_blank"
				style="margin-right: 20px;"
				><button class="header_email el-icon-message" style="cursor: pointer;"></button
			></a>
			<div class="serch_box" @keydown.enter="goSearchList">
				<el-input
					placeholder="请输入搜索内容"
				
					v-model="inp_search"
				>
				</el-input>
			</div>
		</div>

		<div class="header">
			<div class="h_logo">
				<!-- <img src="@/assets/logo.png" alt="logo" /> -->
				<img
					ref="logos"
					src="@/assets/logo-footer.png"
					alt="logo"
					@click="gohome"
				/>
			</div>
			<div class="pc_disNone">
				<p @click="show_menu">
					<img src="../assets/menu.png" />
				</p>
			</div>
			<ul class="m_disNone h_nav">
				<li
					:class="{ on: tab_on == '/' }"
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/">首页</router-link>
				</li>
				<li
					:class="{ on: tab_on == '/product' }"
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<!-- {{ menu_product[0].id }} -->
					<router-link :to="'/product/productdetail/' + menu_product[0].id"
						>产品中心</router-link
					>
					<div class="select_menu">
						<router-link
							:to="
								item.child.length
									? `/product/productdetail/${item.id}`
									: `/product/profile/${item.id}`
							"
							v-for="item in menu_product"
							tag="p"
							:key="item.id"
							>{{ item.name }}</router-link
						>
					</div>
				</li>
				<li
					:class="{ on: tab_on == '/solution' }"
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/solutionindex">解决方案</router-link>
					<div class="select_menu">
						<router-link
							:to="
								item.child.length
									? `/solution/solutiondetail/${item.id}`
									: `/solution/profile/${item.id}`
							"
							v-for="item in menu_solution"
							tag="p"
							:key="item.id"
							>{{ item.name }}</router-link
						>
					</div>
				</li>
				<li
					:class="{ on: tab_on == '/operation' }"
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/operation">运维服务</router-link>
				</li>
				<li
					:class="{ on: tab_on == '/investor' }"
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/investor">关于我们</router-link>
					<div class="select_menu">
						<p @click.stop="goAbout()"><a href="#about_anchor_introduce" style="color:#fff;text-decoration:none">公司简介</a></p>
						<p @click.stop="goAbout()"><a href="#about_anchor_dees" style="color:#fff;text-decoration:none">发展历程</a></p>
						<p @click.stop="goAbout()"><a href="#about_anchor_join" style="color:#fff;text-decoration:none">企业文化</a></p>
						<p @click.stop="goAbout()"><a href="#about_anchor_director" style="color:#fff;text-decoration:none">质量方针</a></p>
					</div>
				</li>
			</ul>
		</div>
		<div ref="m_header" class="m_header">
			<div class="close" @click="show_menu"></div>

			<ul>
				<li class="on">
					<router-link to="/">
						<p>首页</p>
					</router-link>
				</li>
				<li>
					<router-link :to="'/product/productdetail/' + menu_product[0].id"><p>产品中心</p></router-link>
				</li>
				<li>
					<router-link :to="'/solution/solutiondetail/'+menu_solution[0].id"><p>解决方案</p></router-link>
				</li>
				<li>
					<router-link to="/operation"><p>运维服务</p></router-link>
				</li>
				<li>
					<router-link to="/investor"><p>关于我们</p></router-link>
				</li>
			</ul>
		</div>
		<!-- aside -->
		<div class="aside">
			<ul>
				<li class="tel_aside">
					<i class="qq_bck"></i>
					<p>QQ咨询</p>
					<div class="tel_h_content">
						<div class="tel_box">
							<img src="../assets/tel_box.png" alt="" />
							<div class="tel_h_b">
								<p>客服QQ</p>
								<p>{{qqNum}}</p>
							</div>
						</div>
					</div>
				</li>
				<li class="tel_aside">
					<i class="tel_bck"></i>
					<p>联系电话</p>
					<div class="tel_h_content">
						<div class="tel_box">
							<img src="../assets/tel_box.png" alt="" />
							<div class="tel_h_b">
								<p>客服电话</p>
								<p>{{phoneOne}}</p>
								<p>{{phoneTwo}}</p>
							</div>
						</div>
					</div>
				</li>
				<li class="wx_aside">
					<i class="wx_bck"></i>
					<p>官方微信</p>
					<div class="tel_h_content">
						<img :src="src" alt="" />
					</div>
				</li>
				<li>
					<a href="#">
						<i class="top_bck"></i>
						<p>返回顶部</p>
					</a>
				</li>
			</ul>
		</div>
		<!-- online -->
		<div class="online" @click="leaving"></div>
		<!-- m_侧边栏 -->
		<!-- <div class="m_aside" @click="leaving"></div> -->
	</div>
</template>
<script>
import Axios from 'axios'
export default {
	// props:[],
	data() {
		return {
			show: false,
			tab_on: '/',
			inp_on: false,
			inp_search: '',
			i: 0,
			src: '',
			qqNum:'',
			phoneOne:'',
			phoneTwo:'',
			menu_product: [],
			menu_solution: [],
		}
	},
	mounted() {
		this.init()
		window.addEventListener('scroll', this.handleScroll)
		Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
			window.sessionStorage.setItem('commonContent',JSON.stringify(res.data.data.rows))
			for (var i = 0; i < res.data.data.rows.length; i++) {
				if (res.data.data.rows[i].sc_key.slice(0, 6) == 'QRCODE') {
					this.src = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 5) == 'QQNUM') {
					this.qqNum = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 8) == 'PHONEONE') {
					this.phoneOne = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 8) == 'PHONETWO') {
					this.phoneTwo = res.data.data.rows[i].sc_value
				}
			}
		})
		Axios({
			url:'/apiv2/bdoctree/gettree?bdContenttype=产品中心',
			data: {},
			method: 'GET',
		}).then((res) => {
			this.menu_product = res.data.data
		})
		Axios({
			url: '/apiv2/bdoctree/gettree?bdContenttype=解决方案',
			data: {},
			method: 'GET',
		}).then((res) => {
			this.menu_solution = res.data.data
		})
	},
	methods: {
		goAbout(){
			this.$router.push('/investor')
		},
		goSearchList() {
			Axios({
				url:`/apiv2/bdoc/searchList?keyword=${this.inp_search}`,
				method: 'GET',
			}).then((res) => {
				window.sessionStorage.setItem(
					'data',
					JSON.stringify(res.data.data.rows)
				)
				if (this.$route.path == '/search') {
					this.$emit('searchPage', 1, JSON.stringify(res.data.data.rows))
					return
				} else {
					this.$router.push('/search')
				}
			})
		},
		show_menu() {
			this.show = !this.show
			if (this.show) {
				this.$move(
					this.$refs.m_header,
					{ height: '100' },
					{ company: 'vh', type: 'easeInStrong' }
				)
			} else {
				this.$move(this.$refs.m_header, { height: 0 }, { type: 'easeInStrong' })
			}
		},
		en_select_menu(e) {
			if (e.target.children[1]) {
				var oTarget = e.target.children[1]
				var oH = oTarget.children[0].offsetHeight * oTarget.children.length
				this.$move(oTarget, { height: oH }, { type: 'easeIn', time: 50 })
			}
		},
		dis_select_menu(e) {
			if (e.target.children[1]) {
				var oTarget = e.target.children[1]
				this.$move(oTarget, { height: 0 }, { type: 'easeIn', time: 50 })
			}
		},
		gohome() {
			this.$router.push('/')
		},
		init() {
			this.tab_on = this.$route.path
		},
		leaving() {
			this.$router.push('/leaving')
		},
		expand() {
			this.inp_on = !this.inp_on
		},
		handleScroll() {
			// 页面滚动距顶部距离
			var scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop
			var scroll = scrollTop - this.i
			this.i = scrollTop
			if (scroll < 0 && scrollTop !== 0) {
				this.$refs.header.style.height = 122 + 'px'
				this.$refs.header.style.background = '#fff'
				this.$refs.header.style.opacity = '1'
				this.$refs.logos.src = require('@/assets/logo.png')
				this.$refs.header.classList.add('h_fixed')
			} else if (scrollTop < 130) {
				this.$refs.header.style.background = 'rgba(0,0,0,0.4)'
				this.$refs.header.classList.remove('h_fixed')
				this.$refs.header.style.opacity = '1'
				this.$refs.logos.src = require('@/assets/logo-footer.png')
			} else {
				this.$refs.header.style.height = 0 + 'px'
				this.$refs.header.style.background = 'rgba(0,0,0,0.4)'
				this.$refs.header.classList.remove('h_fixed')
				this.$refs.logos.src = require('@/assets/logo-footer.png')
				this.$refs.header.style.opacity = '0'
			}
		},
	},
}
</script>
<style lang="scss" scoped >
@media (min-width: 1200px) {
	@import '../style/base.scss';
	@import '../style/header.scss';
}
@media (max-width: 1199px) {
	@import '../style/mb.scss';
	@import '../style/m-header.scss';
}
</style>